// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2QBl6","label":"Completed_label__2f8YW"};